const apiUrl = import.meta.env.VITE_API_URL as string

const env = {
  API_URL: apiUrl,
  COGNITO_POOL_ID: import.meta.env.VITE_COGNITO_POOL_ID as string,
  COGNITO_CLIENT_ID: import.meta.env.VITE_COGNITO_CLIENT_ID as string,
  IS_PRODUCTION: import.meta.env.PROD,
  IS_DEVELOPMENT: import.meta.env.DEV,
  IS_TEST: apiUrl?.includes('test') || import.meta.env.DEV,
} as const

// Validate required env vars
const requiredEnvVars = ['API_URL', 'COGNITO_POOL_ID', 'COGNITO_CLIENT_ID'] as const

for (const key of requiredEnvVars) {
  if (!env[key]) {
    console.warn(`Missing required environment variable: VITE_${key}`)
  }
}

export { env }
